var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"table",attrs:{"service":_vm.PaymentTypeService,"entity":_vm.entity,"columns":_vm.columns,"disablePermissionChecks":true,"operations":"refresh"},scopedSlots:_vm._u([{key:"created_at",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(_vm.$formatDate(row.created_at))+"\n    ")]}},{key:"third_party",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.third_party || '--')+"\n    ")]}},{key:"type",fn:function(ref){
var row = ref.row;
return [_c('status-badge',{attrs:{"type":"primary","status":row.type}},[_vm._v("\n        "+_vm._s(row.type)+"\n      ")])]}},{key:"active",fn:function(ref){
var row = ref.row;
return [_c('base-switch',{attrs:{"value":row.active},on:{"input":function($event){return _vm.onActiveChange($event, row)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }